import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
} from "@mui/material";

import { accessoriesService } from "../service/AccessoriesService";

const AccessoriesPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔥 FILTER STATE (UPDATED)
  const [filters, setFilters] = useState({
    itemType: "",
    startDate: "",
    endDate: "",
    month: "",
    filterYear: "",
  });

  // 🔥 POPUP STATE
  const [open, setOpen] = useState(false);

  // 🔥 FORM STATE (UPDATED)
  const [form, setForm] = useState({
    itemType: "",
    price: "",
    quantity: "",
    year: new Date().getFullYear(),
    date: "",
  });

  const itemOptions = ["Helmet", "Seat Cover", "Bike Cover", "Gift"];

  // 🔄 FILTER CHANGE
  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  // 🔄 FORM CHANGE
  const handleFormChange = (e) => {
    const { name, value } = e.target;

    // 🔥 AUTO YEAR FROM DATE
    if (name === "date") {
      const year = new Date(value).getFullYear();
      setForm({ ...form, date: value, year });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  // 🚀 FETCH DATA
  const fetchData = async (customFilters = filters) => {
  try {
    setLoading(true);

    const res = await accessoriesService.getCategoryReport(customFilters);

    console.log("API DATA:", res);

    setData(res.data || []);
    console.log(res.data)
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  fetchData({}); // 🔥 IMPORTANT: no filters
}, []);

  // 🔍 SEARCH
const handleSearch = () => {
  fetchData(filters);
};
  // 🔄 RESET
const handleReset = () => {
  const emptyFilters = {
    itemType: "",
    startDate: "",
    endDate: "",
    month: "",
    filterYear: "",
  };

  setFilters(emptyFilters);

  // 🔥 CALL WITHOUT FILTERS
  fetchData({});
};

  // ➕ CREATE
  const handleCreate = async () => {
    try {
      await accessoriesService.createAccessory(form);
      setOpen(false);
      fetchData();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Accessories Management
      </Typography>

      {/* 🔥 FILTER SECTION */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <TextField
              select
              label="Item Type"
              name="itemType"
              fullWidth
              value={filters.itemType}
              onChange={handleChange}
            >
              {itemOptions.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              label="Start Date"
              type="date"
              name="startDate"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={filters.startDate}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              label="End Date"
              type="date"
              name="endDate"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={filters.endDate}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              label="Month (1-12)"
              name="month"
              type="number"
              fullWidth
              value={filters.month}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              label="Year"
              name="filterYear"
              fullWidth
              value={filters.filterYear}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={6} md={3}>
            <Button variant="contained" fullWidth onClick={handleSearch}>
              Search
            </Button>
          </Grid>

          <Grid item xs={6} md={3}>
            <Button variant="outlined" fullWidth onClick={handleReset}>
              Reset
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* ➕ CREATE BUTTON */}
      <Button
        variant="contained"
        color="success"
        onClick={() => setOpen(true)}
        sx={{ mb: 2 }}
      >
        + Create Accessories
      </Button>

      {/* 🔥 TABLE */}
      {loading ? (
        <CircularProgress />
      ) : (
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Item</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Price</TableCell>
                <TableCell>Total</TableCell>
              </TableRow>
            </TableHead>

          <TableBody>
  {data.length === 0 ? (
    <TableRow>
      <TableCell colSpan={5} align="center">
        No Data Found ❌
      </TableCell>
    </TableRow>
  ) : (
    data.map((row, index) => (
      <TableRow key={index}>
        {/* Item Type */}
        <TableCell>{row?.itemType || "-"}</TableCell>

        {/* Date */}
        <TableCell>
          {row?.date
            ? new Date(row.date).toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
            : "-"}
        </TableCell>

        {/* Quantity */}
        <TableCell>{row?.totalQuantity ?? 0}</TableCell>

        {/* Avg Price */}
        <TableCell>
          {row?.avgPrice !== undefined
            ? Number(row.avgPrice).toFixed(2)
            : "0.00"}
        </TableCell>

        {/* Total Amount */}
        <TableCell>{row?.totalAmount ?? 0}</TableCell>
      </TableRow>
    ))
  )}
</TableBody>
          </Table>
        </Paper>
      )}

      {/* 🔥 CREATE DIALOG */}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Create Accessories</DialogTitle>

        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                select
                label="Item Type"
                name="itemType"
                fullWidth
                value={form.itemType}
                onChange={handleFormChange}
              >
                {itemOptions.map((item) => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Price"
                name="price"
                type="number"
                fullWidth
                value={form.price}
                onChange={handleFormChange}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Quantity"
                name="quantity"
                type="number"
                fullWidth
                value={form.quantity}
                onChange={handleFormChange}
              />
            </Grid>

            {/* 🔥 DATE FIELD (CALENDAR) */}
            <Grid item xs={12}>
              <TextField
                label="Date"
                name="date"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={form.date}
                onChange={handleFormChange}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Year"
                name="year"
                fullWidth
                value={form.year}
                onChange={handleFormChange}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
          <Button variant="contained" onClick={handleCreate}>
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AccessoriesPage;